import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';

const TermsOfService = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('termsOfService')}</h1>
        <p>{t('lastUpdated')} {new Date().toLocaleDateString()}</p>
      </header>

      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '800px', margin: '0 auto' }}>
        <section>
          <h2>{t('acceptanceOfTerms')}</h2>
          <p>{t('acceptanceOfTermsDescription')}</p>
        </section>

        <section>
          <h2>{t('descriptionOfService')}</h2>
          <p>{t('descriptionOfServiceDescription')}</p>
          <ul>
            <li>{t('personalizedVocabulary')}</li>
            <li>{t('interactiveFlashcards')}</li>
            <li>{t('aiGeneratedSentences')}</li>
            <li>{t('conversationalAITutoring')}</li>
            <li>{t('progressTracking')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('userAccounts')}</h2>
          <p>{t('userAccountsDescription')}</p>
          <ul>
            <li>{t('maintainConfidentiality')}</li>
            <li>{t('allActivities')}</li>
            <li>{t('provideAccurateInfo')}</li>
            <li>{t('notifyUnauthorized')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('acceptableUse')}</h2>
          <p>{t('acceptableUseDescription')}</p>
          <ul>
            <li>{t('useForIllegal')}</li>
            <li>{t('gainUnauthorizedAccess')}</li>
            <li>{t('interfereWithService')}</li>
            <li>{t('shareCredentials')}</li>
            <li>{t('useAutomatedTools')}</li>
            <li>{t('createHarmfulContent')}</li>
            <li>{t('inappropriateContentPolicy')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('intellectualProperty')}</h2>
          <p>{t('intellectualPropertyDescription')}</p>
        </section>

        <section>
          <h2>{t('privacy')}</h2>
          <p>{t('privacyDescription')}</p>
        </section>

        <section>
          <h2>{t('disclaimers')}</h2>
          <p>{t('disclaimersDescription')}</p>
        </section>

        <section>
          <h2>{t('limitationOfLiability')}</h2>
          <p>{t('limitationOfLiabilityDescription')}</p>
        </section>

        <section>
          <h2>{t('termination')}</h2>
          <p>{t('terminationDescription')}</p>
        </section>

        <section>
          <h2>{t('refundPolicyTitle') || 'Refund Policy'}</h2>
          <p>{t('refundPolicy')}</p>
        </section>

        <section>
          <h2>{t('changesToTerms')}</h2>
          <p>{t('changesToTermsDescription')}</p>
        </section>

        <section>
          <h2>{t('contactInformation')}</h2>
          <p>
            {t('contactInformationDescription')}
            <br />
            {t('supportPhoneLabel')} <a href="tel:+16179420829">(617) 942-0829</a>
          </p>
        </section>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default TermsOfService; 